import { of } from 'rxjs/observable/of';
import { Observable } from 'rxjs';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { switchMap, catchError, concatMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Action } from 'redux-actions';

import {
	GET_OUTING_PUNCH_ATTACHMENT_CALL,
	DELETE_OUTING_PUNCH_ATTACHMENTS_CALL,
	DELETE_OUTING_PUNCH_CALL,
	GET_OUTING_PUNCH_CALL,
	GET_OUTING_PUNCH_SETTING_CALL,
	POST_OUTING_PUNCH_CALL,
} from '@src/store/types/outingPunch';
import {
	getOutingPunchAttachment,
	deleteOutingPunchAttachments,
	deleteOutingPunch,
	getOutingPunch,
	getOutingPunchSetting,
	postOutingPunch,
} from '@src/services/outingPunch';
import {
	getOutingPunchAttachmentDone,
	getOutingPunchAttachmentFail,
	deleteOutingPunchAttachmentsDone,
	deleteOutingPunchAttachmentsFail,
	deleteOutingPunchDone,
	deleteOutingPunchFail,
	getOutingPunchDone,
	getOutingPunchFail,
	getOutingPunchSettingDone,
	getOutingPunchSettingFail,
	postOutingPunchDone,
	postOutingPunchFail,
} from '@src/store/actions/outingPunch';

export const getOutingPunchSettingEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_OUTING_PUNCH_SETTING_CALL),
	switchMap(
		() => fromPromise(getOutingPunchSetting()).pipe(
			switchMap(res => of(getOutingPunchSettingDone({ res }))),
			catchError(error => of(getOutingPunchSettingFail({ error }))),
		),
	),
);

export const getOutingPunchEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_OUTING_PUNCH_CALL),
	switchMap(
		() => fromPromise(getOutingPunch()).pipe(
			switchMap(res => of(getOutingPunchDone({ res }))),
			catchError(error => of(getOutingPunchFail({ error }))),
		),
	),
);

export const postOutingPunchEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(POST_OUTING_PUNCH_CALL),
	switchMap(
		({ payload }) => fromPromise(postOutingPunch(payload)).pipe(
			switchMap(res => {
				if (payload.onSuccess) payload.onSuccess(res);
				return of(postOutingPunchDone({ res }));
			}),
			catchError(error => {
				if (payload.onError) payload.onError(error.response);
				return of(postOutingPunchFail({ error }));
			}),
		),
	),
);

export const deleteOutingPunchEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(DELETE_OUTING_PUNCH_CALL),
	switchMap(
		({ payload }) => fromPromise(deleteOutingPunch(payload)).pipe(
			switchMap(res => {
				if (payload.onSuccess) payload.onSuccess(res);
				return of(deleteOutingPunchDone({ res }));
			}),
			catchError(error => {
				if (payload.onError) payload.onError(error.response);
				return of(deleteOutingPunchFail({ error }));
			}),
		),
	),
);

export const getOutingPunchAttachmentEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(GET_OUTING_PUNCH_ATTACHMENT_CALL),
	concatMap(
		({ payload }) => fromPromise(getOutingPunchAttachment(payload)).pipe(
			switchMap(res => of(getOutingPunchAttachmentDone({ id: payload.id, url: res }))),
			catchError(error => of(getOutingPunchAttachmentFail({ error }))),
		),
	),
);

export const deleteOutingPunchAttachmentsEpic = (
	action$: Observable<Action>,
): Observable<Action> => action$.pipe(
	ofType(DELETE_OUTING_PUNCH_ATTACHMENTS_CALL),
	switchMap(
		({ payload }) => fromPromise(deleteOutingPunchAttachments(payload)).pipe(
			switchMap(res => {
				if (payload.onSuccess) payload.onSuccess(res);
				return of(deleteOutingPunchAttachmentsDone({ res }));
			}),
			catchError(error => {
				if (payload.onError) payload.onError(error.response);
				return of(deleteOutingPunchAttachmentsFail({ error }));
			}),
		),
	),
);
